import faker from 'faker';
import moment from 'moment';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            id: index,
            fornecedor: faker.name.findName().toUpperCase(),
            contrato: faker.random.number({min: 1000, max: 5000}),
            documentoCobrancaNumero: faker.random.number({min: 1000, max: 5000}),
            tipoDocumentoCobranca: faker.commerce.department().toUpperCase(),
            valor: faker.commerce.price(100000, 100000000, 2) / 100,
        })
    });